import React from "react";
import { FOLLOW_SOCIALS } from "../../socials";

export default function FooterSocial() {
  return (
    <div>
      <div className="eyebrow text-[hsl(var(--primary))] mb-3">Follow</div>
      <ul className="space-y-3">
        {FOLLOW_SOCIALS.map(({ key, label, handle, href, icon: Icon }) => (
          <li key={key}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 hover:text-[hsl(var(--primary))] transition-colors"
              data-testid={`footer-social-${key}`}
            >
              <Icon size={18} />
              <span className="leading-tight">
                <span className="block font-display uppercase tracking-widest text-sm">{label}</span>
                <span className="block font-body text-sm opacity-70 group-hover:opacity-100">{handle}</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
